$(document).ready(function() {

  $('.sidebar-block h4').each(function() {
        $(this).remove();
});

  $("iframe[src='https://casakids.com/services/login_with_shop/authorize?target_origin=https%3A%2F%2Fcasakids.com&api_key=123&locale=en&analytics_trace_id=08d9e4ae-e2fc-4aaf-85a0-fb7f74ca4057&analytics_context=checkout_sheet&compact_layout=true&flow=checkout_sheet&flow_version=1&checkout_version=checkout_one_checkout_sheet&shop_id=27280804&sign_up_enabled=true']").attr("title", "casakids frame");



  $(".trnbtn").click(function(){

    $('.tcon').toggleClass("usm");
    $(this).attr('aria-expanded', function(i, attr) {
      return attr == 'true' ? 'false' : 'true'
    });
  
  });


  $(".trnbtn2").click(function(){

    $('.tcon2').toggleClass("usm");
    $(this).attr('aria-expanded', function(i, attr) {
      return attr == 'true' ? 'false' : 'true'
    });
  
  });

  $(".shopify-product-reviews .spr-summary-actions-newreview").attr("href", "#");


 
 

  var element = $(".description.destab .tabs li a, .description.salepro .tabs li a");
  element.replaceWith(function() {
      return $("<button>", {
          class: $(this).attr("class"),
          html: $(this).html() 
      });
  });
  element = $(".elementor-accordion-title");


  var element2 = $(".description.destab .tabs, .description.salepro .tabs");
  element2.replaceWith(function() {
      return $("<div>", {
          class: $(this).attr("class"),
          role: $(this).attr("role"),
          html: $(this).html() 
      });
  });
  element2 = $(".elementor-accordion-title");

  var element3 = $(".description.destab .tabs li, .description.salepro .tabs li");
  element3.replaceWith(function() {
      return $("<div>", {
          
          html: $(this).html() 
      });
  });
  element3 = $(".elementor-accordion-title");

  var element4 = $(".description.destab .tabs-content, .description.salepro .tabs-content");
  element4.replaceWith(function() {
      return $("<div>", {
        class: $(this).attr("class"),
          html: $(this).html() 
      });
  });
  element4 = $(".elementor-accordion-title");

  var element5 = $(".description.destab .tabs-content li, .description.salepro .tabs-content li");
  element5.replaceWith(function() {
      return $("<div>", {
        class: $(this).attr("class"),
        role: $(this).attr("role"),
        id: $(this).attr("id"),
        tabindex: $(this).attr("tabindex"),
          html: $(this).html() 
      });
  });
  element5 = $(".elementor-accordion-title");

});


$(document).ready(function(){

$(".hmsect2, .hmsect2 .splide__list li").removeAttr("role");
$(".hmsect2, .hmsect2 .splide__list li").removeAttr("aria-label");
$(".hmsect2, .hmsect2 .splide__list li").removeAttr("aria-roledescription");

$(".tuckbedcla h1").attr("aria-level", "2");

$("br").attr("aria-hidden", "true");
$(".dropdown_container .header_search_form input").attr("aria-label", "search");
$(".hmhead h1, .hmsect2 h1").attr("aria-level", "2");
$(".article a").removeAttr("target");


$(".sidebar-block .blog_search input").attr("aria-label", "search here");

$(".product-wrap .price").each(function (i) {
    $(this).detach().appendTo($(".product-wrap").eq(i))
  });
  
  $(".mapimg").parent().parent().parent(".container").addClass("htmlcont");
  $(".contactform a[href='mailto:info@casakids.com']").attr("aria-label", "email us, info@casakids.com");
  $(".contactform a[href='tel:(718) 694-0272']").attr("aria-label", "call us, (718) 694-0272");
$(".g-recaptcha-response").attr("aria-label", "captcha");

$(".block__page-details-who-template-2 .title.bntxt").attr("aria-level", "1");

  $('.description.destab .tabs button, .description.salepro .tabs button').each(function(index) {
    // 'index' is automatically provided by .each() and is zero-based
    // Add 1 to make it start from 1 instead of 0 for your ID names
    $(this).attr('id', 'tab-' + (index + 1));
    $(this).attr('aria-controls', 'tabpanel-' + (index + 1));
    $(this).attr('role', 'tab');
    $(this).attr('type', 'button');
  });

  $('.description.destab .tabs-content> div, .description.salepro .tabs-content> div').each(function(index) {
    // 'index' is automatically provided by .each() and is zero-based
    // Add 1 to make it start from 1 instead of 0 for your ID names
    $(this).attr('aria-labelledby', 'tab-' + (index + 1));
    $(this).attr('id', 'tabpanel-' + (index + 1));
    $(this).attr('role', 'tabpanel');
    $(this).attr('tabindex', '0');
  });

  $(".description.destab .tabs, .description.salepro .tabs").addClass("automatic");
  $(".description.destab .tabs, .description.salepro .tabs").attr("role", "tablist");
  $(".description.destab .tabs, .description.salepro .tabs").attr("aria-labelledby", "tablist-1");
  $(".description.destab, .description.salepro").attr("role", "region");
  $(".description.destab, .description.salepro").attr("aria-label", "product description tabs");
  $(".tabs").removeAttr("aria-labelledby");

  $(".block__fbb47170-3eb2-431b-a742-f760de68acb3 h2, .block__page-details-remote-template-2 h2, .block__page-details-home-template-2 h2, .block__page-details-showroom-template-2 h2, .block__page-details-brooklyn-template-2 h2, .block__page-details-template-2 h2, .block__b302457e-13ce-4f88-a926-f3e07c31d730 h2").attr("aria-level", "1");
  $("hr").attr("aria-hidden", "true");
  $(".footer_menu .toggle_content li a[href='/pages/accessibility-statement']").attr("id", "accessiblesta");
  $(".recommended-products--slider .products-slider").removeAttr("tabindex");
  $(".cart_content_info .product-quantity-box input").removeAttr("id");
  $("a").removeAttr("title");


class TabsAutomatic {
  constructor(groupNode) {
    this.tablistNode = groupNode;

    this.tabs = [];

    this.firstTab = null;
    this.lastTab = null;

    this.tabs = Array.from(this.tablistNode.querySelectorAll('[role=tab]'));
    this.tabpanels = [];

    for (var i = 0; i < this.tabs.length; i += 1) {
      var tab = this.tabs[i];
      var tabpanel = document.getElementById(tab.getAttribute('aria-controls'));

      tab.tabIndex = -1;
      tab.setAttribute('aria-selected', 'false');
      this.tabpanels.push(tabpanel);

      tab.addEventListener('keydown', this.onKeydown.bind(this));
      tab.addEventListener('click', this.onClick.bind(this));

      if (!this.firstTab) {
        this.firstTab = tab;
      }
      this.lastTab = tab;
    }

    this.setSelectedTab(this.firstTab, false);
  }

  setSelectedTab(currentTab, setFocus) {
    if (typeof setFocus !== 'boolean') {
      setFocus = true;
    }
    for (var i = 0; i < this.tabs.length; i += 1) {
      var tab = this.tabs[i];
      if (currentTab === tab) {
        tab.setAttribute('aria-selected', 'true');
        tab.removeAttribute('tabindex');
        this.tabpanels[i].classList.remove('is-hidden');
        if (setFocus) {
          tab.focus();
        }
      } else {
        tab.setAttribute('aria-selected', 'false');
        tab.tabIndex = -1;
        this.tabpanels[i].classList.add('is-hidden');
      }
    }
  }

  setSelectedToPreviousTab(currentTab) {
    var index;

    if (currentTab === this.firstTab) {
      this.setSelectedTab(this.lastTab);
    } else {
      index = this.tabs.indexOf(currentTab);
      this.setSelectedTab(this.tabs[index - 1]);
    }
  }

  setSelectedToNextTab(currentTab) {
    var index;

    if (currentTab === this.lastTab) {
      this.setSelectedTab(this.firstTab);
    } else {
      index = this.tabs.indexOf(currentTab);
      this.setSelectedTab(this.tabs[index + 1]);
    }
  }

  /* EVENT HANDLERS */

  onKeydown(event) {
    var tgt = event.currentTarget,
      flag = false;

    switch (event.key) {
      case 'ArrowLeft':
        this.setSelectedToPreviousTab(tgt);
        flag = true;
        break;

      case 'ArrowRight':
        this.setSelectedToNextTab(tgt);
        flag = true;
        break;

      case 'Home':
        this.setSelectedTab(this.firstTab);
        flag = true;
        break;

      case 'End':
        this.setSelectedTab(this.lastTab);
        flag = true;
        break;

      default:
        break;
    }

    if (flag) {
      event.stopPropagation();
      event.preventDefault();
    }
  }

  onClick(event) {
    this.setSelectedTab(event.currentTarget);
  }
}

// Initialize tablist

window.addEventListener('load', function () {
  var tablists = document.querySelectorAll('[role=tablist].automatic');
  for (var i = 0; i < tablists.length; i++) {
    new TabsAutomatic(tablists[i]);
  }
});


$(".hmsect2 .caption-content, .hmhead .caption-content").each(function() {
    // For each ".bggle_product-container" element, find the elements with the classes ".headingtext" and ".alaccordi"
    var neoclmn = $(this);
    var link = neoclmn.find("h1,h2");
    var linktc = neoclmn.find("a.action_button");
  
    // Get the text content from the found elements
    var linkText = link.text();
    var linkText2 = linktc.text();
  
    // Set the aria-label attribute on the ".alaccordi" element within the current ".clmna" element
    linktc.attr("aria-label", linkText2 + linkText);
  });

  // $(".hmsect2 .caption-content, .hmhead .caption-content").each(function() {
  //   // For each ".bggle_product-container" element, find the elements with the classes ".headingtext" and ".alaccordi"
  //   var neoclmn = $(this);
  //   var link = neoclmn.find("h1");
  //   var linktc = neoclmn.find("a.action_button");
  
  //   // Get the text content from the found elements
  //   var linkText = link.text();
  //   var linkText2 = linktc.text();
  
  //   // Set the aria-label attribute on the ".alaccordi" element within the current ".clmna" element
  //   linktc.attr("aria-label", linkText2 + linkText);
  // });


});



// $(document).ready(function () {
//     $('a').each(function () {
//       // Check if the link is external
//       if (this.hostname && this.hostname !== window.location.hostname && this.hostname !== 'casakids.com') {
//         // Create a span element with warning text
//         var warningSpan = $('<span class="visuallyhidden"> This link will open in a new tab.</span>');
//         // Set attributes for accessibility
//         $(this).attr('target', '_blank').attr('rel', 'noopener noreferrer');
//         // Append the warning span inside the link
//         $(this).append(warningSpan);
//       }
//     });
//   });


$(document).ready(function () {

  $('a').each(function () {
      // Check if the link is from 'casakids.com'
      if (this.hostname === 'www.casakids.com') {
          // Remove the target and rel attributes from the link
          $(this).removeAttr('target').removeAttr('rel');
      } else if (this.hostname === 'casakids.com') {
        // Remove the target and rel attributes from the link
        $(this).removeAttr('target').removeAttr('rel');
      } else if (this.hostname && this.hostname !== window.location.hostname) {
        // Create a span element with warning text
        var warningSpan = $('<span class="visuallyhidden"> This link will open in a new tab.</span>');
        // Set attributes for accessibility
        $(this).attr('target', '_blank').attr('rel', 'noopener noreferrer');
        // Append the warning span inside the link
        $(this).append(warningSpan);
    }
  });
});



//   Dropdown Menu


$(function() {
  var accordionButtons = $('.maindropdwon');
  var accordionButtons2 = $('.dropcont');

  function accordionToggle() {
    accordionButtons.on('click', function(e) {
      $control = $(this);
      $control2 = $(this).parent().children(".dropcont");

      accordionContent = $control.attr('aria-controls');
      checkOthers($control[0]);

      isAriaExp = $control.attr('aria-expanded');
      newAriaExp = (isAriaExp == "false") ? "true" : "false";
      $control.attr('aria-expanded', newAriaExp);

      // Add or remove 'active' class based on aria-expanded value
      $control2.toggleClass('open', newAriaExp === 'true');

      isAriaHid = $('#' + accordionContent).attr('aria-hidden');
      if (isAriaHid == "true") {
        $('#' + accordionContent).attr('aria-hidden', "false").css('display', 'block');
      } else {
        $('#' + accordionContent).attr('aria-hidden', "true").css('display', 'none');
      }
    });
  };

  function checkOthers(elem) {
    for (var i = 0; i < accordionButtons.length; i++) {
      if (accordionButtons[i] != elem) {
        if ($(accordionButtons[i]).attr('aria-expanded') == 'true') {
          $(accordionButtons[i]).attr('aria-expanded', 'false')
          $(accordionButtons2[i]).removeClass('open');
          content = $(accordionButtons[i]).attr('aria-controls');
          $('#' + content).attr('aria-hidden', 'true').css('display', 'none');
        }
      }
    }
  };

  // Call this function on page load
  accordionToggle();
});


$(document).ready(function() {
    // Store the menu element
    var $menu = $('.dropcont');

    // Close the menu on Escape key press
    $(document).keydown(function(event) {
      if (event.key === 'Escape') {
        $menu.removeClass('open');
        $('.mainlidrop>a.maindropdwon').attr('aria-expanded', 'false');
      }
    });
});


$(document).ready(function () {
  setTimeout(function () {
   

    $(".recommended-products--slider .product-wrap .price").each(function (i) {
      $(this).detach().appendTo($(".product-wrap").eq(i))
    });

    $(".mainprodglry, .prodnav").removeAttr("tabindex");

    $(".spr-summary-actions-newreview").removeAttr("href");
  $(".spr-summary-actions-newreview").attr("role", "button");
  $(".spr-summary-actions-newreview").attr("aria-expanded", "false");
  $(".spr-starrating a").removeAttr("href");
  $(".spr-starrating a").attr("role", "button");
  $(".recommended-products--slider .slider-gallery").removeAttr("tabindex");

  }, 3000);
  }, 3000);




  $( document ).ready(function() {
    var existCondition = setInterval(function() {
     if ($('.mainprodglry').length) { 
      clearInterval(existCondition);
      runMyFunction2();
     }
    }, 2000);
  
    function runMyFunction2(){
     console.log("Slider Loaded");
     $('.ss.gallery-cell').attr('aria-hidden', 'true');
     $('.ss.gallery-cell.is-selected').attr('aria-hidden', 'false');
    }
  }); 
  
  document.addEventListener('DOMContentLoaded', function() {
    // Function to update aria-hidden based on the active class
    function updateAriaHidden() {
        var slides = document.querySelectorAll('.ss.gallery-cell');
        slides.forEach(function(slide) {
            if (slide.classList.contains('is-selected')) {
                // If the slide has the is-selected class, set aria-hidden to false
                slide.setAttribute('aria-hidden', 'false');
            } else {
                // Otherwise, set aria-hidden to true
                slide.setAttribute('aria-hidden', 'true');
            }
        });
    }
  
    // Select the navigation buttons
    var navButtons = document.querySelectorAll('.prodnav .gallery-cell');
  
    // Event listeners for click events on navigation buttons
    navButtons.forEach(function(button) {
        button.addEventListener('click', function() {
            // Wait for the slider to update the active class
            setTimeout(updateAriaHidden, 1000); // Adjust the timeout as needed
        });
    });
  
    // Initial update when the page loads
    updateAriaHidden();
  });



  // backtotopbtn

$(document).ready(function() {
  var backToTopButton = $('#go-top');
  backToTopButton.hide();
  $(window).scroll(function() {
      if ($(this).scrollTop() > 300) {
          backToTopButton.show();
      } else {
          backToTopButton.hide();
      }
  });
  
  backToTopButton.on('click', function(e) {
      e.preventDefault();
      $('html, body').animate({ scrollTop: 0 }, 'slow');
      
      // Set focus to the top of the page or the button itself after scrolling
      setTimeout(function() {
          // $('#backtotop').focus(); // If focusing the top element
          // backToTopButton.focus(); // If focusing the button itself
      }, 600); // Adjust the timeout duration to match the scroll duration
  });
});

$(document).ready(function(){


  $(".transcriptbtn").click(function(){

    $(this).parent(".transcriptdrop").toggleClass("active");
    
  });


});
$(document).ready(function() {
    $('.tabs.automatic button').each(function() {
        $(this).unwrap();
    });
});


$(document).ready(function() {
  $('.sixteen.columns .section.clearfix .paginate span.page a').each(function() {
      var href = $(this).attr('href');
      if (href && !$(this).attr('aria-label')) {
          var pageMatch = href.match(/page=(\d+)/); 
          if (pageMatch) {
              var pageNumber = pageMatch[1];
              $(this).attr('aria-label', 'Page ' + pageNumber);  
          }
      }
  });
});
// Function to be executed after the timer
function timerCompleted() {
  console.log("Timer completed!");
}
setTimeout(timerCompleted, 1000);




$(document).ready(function() {
  $('.sixteen.columns .section.clearfix .paginate span.page.current').prepend('<span class="visually-hidden">Current page</span>');
  });


document.addEventListener('DOMContentLoaded', function() {
    const pagination = document.getElementById('pagination');
    if (pagination) {
      pagination.setAttribute('role', 'navigation');
      pagination.setAttribute('aria-label', 'Pagination');
    }
  });
  


//   $(document).ready(function () {
//     // Check if the view is mobile
//     function isMobileView() {
//         return window.innerWidth <= 768; // Adjust the breakpoint as needed
//     }

//     // Add role="button" only on mobile view
//     function addRoleButtonForMobile() {
//         if (isMobileView()) {
//             $(".toogle-head").attr("role", "button");
//         } else {
//             $(".toogle-head").removeAttr("role");
//         }
//     }

//     // Toggle aria-expanded attribute on click
//     $(".toogle-head").click(function () {
//         $(this).attr("aria-expanded", function (i, attr) {
//             return attr === "true" ? "false" : "true";
//         });
//     });

//     // Add role="button" on page load
//     addRoleButtonForMobile();

//     // Update role="button" on window resize
//     $(window).resize(function () {
//         addRoleButtonForMobile();
//     });
// });



$(document).ready(function () {
  // Check if the view is mobile
  function isMobileView() {
      return window.innerWidth <= 768; // Adjust the breakpoint as needed
  }

  // Add role="button" only on mobile view
  function addRoleButtonForMobile() {
      $(".toogle-head").each(function () {
          if (isMobileView()) {
              $(this).attr("role", "button");
          } else {
              $(this).removeAttr("role");
          }
      });
  }

  // Ensure aria-expanded has an initial value
  $(".toogle-head").each(function () {
      if (!$(this).attr("aria-expanded")) {
          $(this).attr("aria-expanded", "false");
      }
  });

  // Toggle aria-expanded attribute on click
  $(".toogle-head").click(function () {
      $(this).attr("aria-expanded", function (i, attr) {
          return attr === "true" ? "false" : "true";
      });
  });

  // Add role="button" on page load
  addRoleButtonForMobile();

  // Update role="button" on window resize
  $(window).resize(function () {
      addRoleButtonForMobile();
  });
});


$(document).ready(function () {
  $(".mobile_nav").click(function () {
      // Toggle aria-expanded attribute
      $(this).attr("aria-expanded", function (i, attr) {
          return attr === "true" ? "false" : "true";
      });
  });
});


// $(".zoomImg").each(function() {
//   // Find the parent anchor tag containing the zoom image
//   var parentLink = $(this).closest("a.image-slide-link");
  
//   // Extract the title attribute from the parent link
//   var linkTitle = parentLink.attr("title") || "Default title for image";
  
//   // Set the aria-label and alt attributes for the zoomImg
//   $(this).attr("aria-label", linkTitle).attr("alt", linkTitle);
//   $(this).attr('aria-hidden','true');
// });

// $(".image__container img.zoomImg").each(function() {
//   // Find the sibling image that has the alt attribute
//   var siblingImage = $(this).siblings("img[alt]");

//   // Get the alt text from the sibling image
//   var altText = siblingImage.attr("alt") || "Default description";

//   // Set the alt attribute and aria-hidden for the zoomImg
//   $(this).attr("alt", altText);
//   $(this).attr("aria-hidden", "true");
// });


// Mobile Drop-Down menu js

$("#mobile_menu a.parent-link--false").click(function(){

  $(this).attr('aria-expanded', function(i, attr) {
    return attr == 'true' ? 'false' : 'true'
  });

});


$(document).ready(function () {
  // Add role="button" to all elements with the class "parent-link--false"
  $(".parent-link--false").each(function () {
      $(this).attr("role", "button");
  });

  // Ensure aria-expanded has an initial value
  $("#mobile_menu .parent-link--false").each(function () {
      if (!$(this).attr("aria-expanded")) {
          $(this).attr("aria-expanded", "false");
      }
  });

  // Remove link functionality and toggle aria-expanded on click
  $(".parent-link--false").click(function (event) {
      event.preventDefault(); // Prevent default link behavior
      $(this).attr("aria-expanded", function (i, attr) {
          return attr === "true" ? "false" : "true";
      });
  });
});



// Gallery Zoom Image //
document.querySelectorAll(".image__container img.zoomImg").forEach(function(zoomImg) {
  // Find the sibling image with the alt attribute
  var siblingImage = zoomImg.closest(".image__container").querySelector("img[alt]");

  if (siblingImage) {
      // Get the alt text from the sibling image
      var altText = siblingImage.getAttribute("alt") || "Default description";

      // Set the alt attribute and aria-hidden for the zoomImg
      zoomImg.setAttribute("alt", altText);
      zoomImg.setAttribute("aria-hidden", "true");
  }
});



$(document).ready(function () {
$('.blog-slides').removeAttr('tabindex');
});